<template>
  <b-container id="app" style="max-width: 2200px; background-color: transparent;">
    <BusTracker v-if="this.$route.fullPath.startsWith('/bus-tracker')"/>
    <ArrDepBoard v-else-if="this.$route.fullPath.startsWith('/arr-dep-board')"/>
    <ArrDepBoardLg v-else-if="this.$route.fullPath.startsWith('/arr-dep-lg-board')"/>
    <SOSDetail v-else-if="this.$route.fullPath.startsWith('/sos_map')"/>
    <VehicleMapDirect v-else-if="this.$route.fullPath.startsWith('/map')"/>
    <VehicleMapDriver v-else-if="this.$route.fullPath.startsWith('/drivermap')"/>
    <VehicleMapTrack v-else-if="this.$route.fullPath.startsWith('/vehicle-track')"/>
    <VehicleMapTrackFleet v-else-if="this.$route.fullPath.startsWith('/fleet-track')"/>
    <VehicleMapTrackBooking v-else-if="this.$route.fullPath.startsWith('/booking-track')"/>
    <RegisterDirect v-else-if="this.$route.fullPath.startsWith('/register')"/>
    <VehStatusTBNDVIR v-else-if="this.$route.fullPath.startsWith('/status')"/>
    <VehStatusMaintTBN v-else-if="this.$route.fullPath.startsWith('/vsm-maint-tbn')"/>
    <VehStatusMaint v-else-if="this.$route.fullPath.startsWith('/vsm-maint')"/>
    <VehMaintSummary v-else-if="this.$route.fullPath.startsWith('/veh-maint-summary')"/>
    <VehStatusTBN v-else-if="this.$route.fullPath.startsWith('/vsm-tbn')"/>
    <VehStatusFasttrakDVIR v-else-if="this.$route.fullPath.startsWith('/vsm-fasttrak')"/>
    <PlannedVehicleTypesMonthlyTBN v-else-if="this.$route.fullPath.startsWith('/vehicle-util-monthly-tbn')"/>
    <VehStatus v-else-if="this.$route.fullPath.startsWith('/vsm-v1')"/>
    <VehStatusES v-else-if="this.$route.fullPath.startsWith('/vsm-es')"/>
    <VehStatusDVIR v-else-if="this.$route.fullPath.startsWith('/vsm')"/>
    <div v-else-if="authenticated">
      <navbar @authenticated="setAuthenticated" v-if="authenticated"/>
      <b-alert v-model="alert.show" :variant="alert.variant" dismissible fade id="root-alert">
        {{alert.message}}
      </b-alert>
      <router-view @authenticated="setAuthenticated" @showAlert="showAlert" />
      <div style="color: #007ac7; font-family: 'inherit' ;font-size: 24px; margin:100px 100px 50px 100px; padding:20px; border-top: 2px dotted #ccc;">
        powered by &#8594; <a target="_new" href="https://www.initekconsulting.com/fleet-integrations"><img height="40" src="/initek-logo.png"/></a>
        <span v-if="user.role == 'admin'" style="font-size: 18px"><br/>{{user.tenant}}</span>
      </div>
    </div>
    <div v-else id="login_top" style="min-height:100vh;background-size:contain;overflow:hidden">
      <Login @authenticated="setAuthenticated" @showAlert="showAlert"/>
    </div>
  </b-container>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import navbar from './components/navbar'
import Login from './components/login'
import SOSDetail from './components/sos_detail'
import VehicleMapDirect from './components/vehicle_map_direct'
import VehicleMapDriver from './components/vehicle_map_driver'
import PlannedVehicleTypesMonthlyTBN from './components/planned_vehicle_types_monthly_tbn.vue'
import VehicleMapTrack from './components/vehicle_map_track'
import VehicleMapTrackFleet from './components/vehicle_map_track_fleet'
import VehicleMapTrackBooking from './components/vehicle_map_by_booking'
import RegisterDirect from './components/direct_register'
import VehStatusTBNDVIR from './components/vehicle_status_dvir_tbn'
import VehStatusFasttrakDVIR from './components/vehicle_status_dvir_fasttrak'
import VehStatusMaintTBN from './components/vehicle_status_maint_tbn'
import VehStatusMaint from './components/vehicle_status_maint'
import VehMaintSummary from './components/vehicle_maint_summary'
import VehStatusTBN from './components/vehicle_status_tbn'
import VehStatus from './components/vehicle_status'
import VehStatusES from './components/vehicle_status_es'
import VehStatusDVIR from './components/vehicle_status_dvir'
import BusTracker from './components/bus_tracker'
import ArrDepBoard from './components/arrivals_departures_board'
import ArrDepBoardLg from './components/arrivals_departures_board_large'
import Planned_vehicle_types_monthly_tbn from "./components/planned_vehicle_types_monthly_tbn.vue";

export default {
  name: 'App',
  metaInfo: {
          title: "Fleet Integrations",
          titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      authenticated: false,                                     
      alert: {
        show: false,
        message: '',
        variant: ''
      },
    }
  },
  components: {
    Planned_vehicle_types_monthly_tbn,
    navbar, Login, SOSDetail, VehicleMapDirect, VehicleMapDriver, VehicleMapTrack, VehicleMapTrackFleet, VehicleMapTrackBooking, RegisterDirect, VehStatusTBNDVIR, VehStatusFasttrakDVIR, VehStatusTBN, VehStatusDVIR, VehStatusMaintTBN, VehStatusMaint, VehStatus, VehStatusES, VehMaintSummary, BusTracker, ArrDepBoard, ArrDepBoardLg, PlannedVehicleTypesMonthlyTBN
  },
  created() {
    if (this.$route.fullPath.startsWith('/vehicle-util-monthly-tbn') ||this.$route.fullPath.startsWith('/bus-tracker') || this.$route.fullPath.startsWith('/arr-dep') || this.$route.fullPath.startsWith('/sos_map') || this.$route.fullPath.startsWith('/map') ||
        this.$route.fullPath.startsWith('/drivermap') || this.$route.fullPath.startsWith('/vehicle-track') || this.$route.fullPath.startsWith('/fleet-track') || this.$route.fullPath.startsWith('/booking-track') ||
        this.$route.fullPath.startsWith('/register') || this.$route.fullPath.startsWith('/status') || this.$route.fullPath.startsWith('/vsm') || this.$route.fullPath.startsWith('/veh-maint-summary')) {
      return;
    }

    const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null

    if (user == null || this.$route.name == "login") {
      this.$router.replace({name: "login", params: {nextUrl: this.$route.fullPath}});
    } else {
      let selected_tenant = localStorage.getItem('selected_tenant')
      if (selected_tenant != null) {
        console.log("setting previously selected tenant: " + selected_tenant)
        user.tenant = selected_tenant
      }

      this.set_user_data(user)
      this.authenticated = true;
    }
  },
  // mounted() {
  //   console.log("mounted: " + this.$route.fullPath)
  //   const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
  //   console.log("mounted3: user=" + user)
  //   this.set_user_data(user)
  //
  //   if (!user || this.$route.name != "login") {
  //     console.log("mounted4: login redirect")
  //     this.$router.replace({name: "login", params: {nextUrl: this.$route.fullPath}});
  //   } else {
  //     this.authenticated = true;
  //   }
  // },
  methods: {
    setAuthenticated(status) {
      this.authenticated = status;
      if (!status) {
        this.logout();
      }
    },
    logout() {
      localStorage.clear()
    },
    showAlert(msg, variant, autoclose) {
      this.alert.show = true
      this.alert.message = msg
      this.alert.variant = variant
      autoclose
          ? setTimeout(() => this.closeAlert(), autoclose)
          : null
    },
    closeAlert() {
      this.alert.show = false
      this.alert.message = ''
      this.alert.variant = ''
    },
    ...mapMutations('profile', [ 'set_user_data' ]),
  },
  computed:{
    ...mapState({
      user: state => state.profile.user,
    })
  }
}
</script>

<style>
.bg-info {
  background-color: steelblue !important;
}

a { color: steelblue !important; }

.page-item.active .page-link {
  color: white !important;
  background-color: steelblue !important;
}
.btn-secondary { color: white !important; }

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 0px;
  background-color: transparent !important;
}

.container {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

</style>
